import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
	BUYING_GROUP_REQUEST,
	BUYING_GROUP_CREATE,
	BUYING_GROUP_DELETE,
	BUYING_GROUP_EDIT,
	BUYING_GROUP_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const BuyingGroupSetup = ({
	auth: { auth, isAuthenticated },
	valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
	fetchBuyingGroup,
	submitBuyingGroupCreate,
	submitBuyingGroupDelete,
	submitBuyingGroupEdit,
	changeReducerState
}) => {

	// states declarations
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
	const [inputVal, setInputVal] = useState('');
	const [deleteBuyingGroupId, setDeleteBuyingGroupId] = useState('');
	const [editBuyingGroupId, setEditBuyingGroupId] = useState('');
	const [editBuyingGroup, setEditBuyingGroup] = useState('');

	// use effect function called for authentication
	useEffect(() => {
		if (isAuthenticated) {
			fetchBuyingGroup(auth[0].token);
		}
	}, [auth, isAuthenticated]);

	// use effect function called after api success
	useEffect(() => {
		if (isCreated === true) {
			toast.success("BuyingGroup Created Successfully.");
			fetchBuyingGroup(auth[0].token);
			changeReducerState();
		}
		if (isDeleted === true) {
			toast.success("BuyingGroup Deleted Successfully.");
			fetchBuyingGroup(auth[0].token);
			changeReducerState();
		}
		if (isEdited === true) {
			toast.success("BuyingGroup Data Updated Successfully.");
			fetchBuyingGroup(auth[0].token);
			changeReducerState();
		}
	}, [isCreated, isDeleted, isEdited]);

	// function to open create modal
	const showCreateModal = () => {
		setCreateModalOpen(true);
	};

	// function to close create modal
	const hideCreateModal = () => {
		setCreateModalOpen(false);
	};

	// function called for input value change of create modal
	const handleCreateModalChange = (e) => {
		setInputVal(e.target.value);
	}

	// function called for create age demographic create api
	const handleCreateModalSubmit = (e) => {
		e.preventDefault();
		if (inputVal === '') {
			toast.error("BuyingGroup name cannot be empty.");
		} else {
			submitBuyingGroupCreate({
				"data": {
					"BuyingGroup": inputVal,
					"CreatedBy": auth[0].userId
				},
				"token": auth[0].token
			});
			hideCreateModal();
		}
	}

	// function to open confirm delete modal
	const showConfirmDeleteModal = (id) => {
		setDeleteBuyingGroupId(id);
		setConfirmDeleteModal(true);
	};

	// function to close confirm delete modal
	const hideConfirmDeleteModal = () => {
		setDeleteBuyingGroupId('');
		setConfirmDeleteModal(false);
	};

	// function called for delete age demographic delete api
	const handleConfirmDeleteSubmit = () => {
		submitBuyingGroupDelete({
			"BuyingGroupId": deleteBuyingGroupId,
			"token": auth[0].token
		});
		hideConfirmDeleteModal();
	}

	// function called on edit icon click
	const handleEditClick = (data) => {
		setEditBuyingGroupId(data.buyingGroupId);
		setEditBuyingGroup(data.buyingGroup);
	}

	// function called to save edited data
	const handleEditSaveClick = (data) => {
		if (editBuyingGroup === '') {
			toast.error("BuyingGroup name cannot be empty.");
		} else {
			submitBuyingGroupEdit({
				"data": {
					"BuyingGroupId": data.buyingGroupId,
					"BuyingGroup": editBuyingGroup,
				},
				"token": auth[0].token
			});
			setEditBuyingGroupId('');
			setEditBuyingGroup('');
		}
	}

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<MainWrapper>
			<Loader loading={isLoading}>
				<div className="container">

					<div className="sub-header mt-5 mb-3">
						<h2>BuyingGroup</h2>
						<Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
						<Create
							variant="primary"
							title={`BuyingGroup`}
							createModalOpen={createModalOpen}
							showCreateModal={showCreateModal}
							hideCreateModal={hideCreateModal}
							inputVal={inputVal}
							handleCreateModalChange={handleCreateModalChange}
							handleCreateModalSubmit={handleCreateModalSubmit}
						/>
					</div>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>BuyingGroup</th>
								<th width="50">Delete</th>
							</tr>
						</thead>
						<tbody>
							{valueList && valueList.length > 0 ? (
								valueList.map((item, index) => (
									<tr key={index}>
										{editBuyingGroupId === item.buyingGroupId ? (
											<td>
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editBuyingGroup} onChange={(evt) => setEditBuyingGroup(evt.target.value)} />
														<Button variant="outline-secondary">
															<Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
														</Button>
													</InputGroup>
												</Form.Group>
											</td>
										) : (
											<td>
												{item.buyingGroup}
												<Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
											</td>
										)}
										<td>
											<ConfirmDelete variant="primary" title={`BuyingGroup`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.buyingGroupId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2}>
										No Data Found.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</Loader>
		</MainWrapper>
	);
}

const mapStateToProps = ({ auth, valueList }) => {
	return {
		auth,
		valueList
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchBuyingGroup: (token) => dispatch({ type: BUYING_GROUP_REQUEST, token }),
		submitBuyingGroupCreate: (data) => dispatch({ type: BUYING_GROUP_CREATE, payload: data }),
		submitBuyingGroupDelete: (data) => dispatch({ type: BUYING_GROUP_DELETE, payload: data }),
		submitBuyingGroupEdit: (data) => dispatch({ type: BUYING_GROUP_EDIT, payload: data }),
		changeReducerState: () => dispatch({ type: BUYING_GROUP_STATE_CHANGE })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(BuyingGroupSetup);